import {
  FormatDistanceFnOptions,
  FormatDistanceToken,
  formatDuration,
} from 'date-fns';
import { enUS } from 'date-fns/locale';

const formatDistance = {
  lessThanXSeconds: '<{{count}}s',
  xSeconds: '{{count}}s',
  halfAMinute: '30s',
  lessThanXMinutes: '<{{count}}m',
  xMinutes: '{{count}}m',
  aboutXHours: '~{{count}}h',
  xHours: '{{count}}h',
  xDays: '{{count}}d',
  aboutXWeeks: '~{{count}}w',
  xWeeks: '{{count}}w',
  aboutXMonths: '~{{count}}m',
  xMonths: '{{count}}m',
  aboutXYears: '~{{count}}r',
  xYears: '{{count}}r',
  overXYears: '>{{count}}r',
  almostXYears: '<{{count}}r',
};

const shortLocale = enUS;
shortLocale.formatDistance = (
  token: FormatDistanceToken,
  count: number,
  options?: FormatDistanceFnOptions,
) => formatDistance[token].replace('{{count}}', count.toString());

export const formatShortDuration = (seconds?: number): string | undefined => {
  if (!seconds) return undefined;

  const totalSeconds = Math.floor(seconds);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  const years = Math.floor(days / 365);
  const remainingDays = days % 365;

  return formatDuration(
    { years, days: remainingDays, hours, minutes, seconds: secs },
    {
      format: ['years', 'days', 'hours', 'minutes', 'seconds'],
      locale: shortLocale,
    },
  );
};
